import { useLocation, NavLink, Outlet } from "react-router-dom";
import ModalRemboursementFournisseur from "../Comptability/ModalRemboursementFournisseur";
import { useEffect, useRef, useState } from "react";
import { decryptData, deleter } from "../components/const";
import Paiements from "../Clients/Paiements";
import $ from "jquery"
import ModalEditeAvanceFournisseur from "../Comptability/ModalEditeAvanceFournisseur";





const CompteFournisseur = () => {
    const user = decryptData("USER")
    const [selectedFacture, setFacture] = useState(null)
    const [total, setTotal] = useState(0);
    const [totalPaye, setTotalPaye] = useState(0);
    const [totalAvance, setTotalAvance] = useState(0);
    const tableRef = useRef()
    const tableRef2 = useRef()
    const tableRef3 = useRef()
    const handleSetSelect = (fact) => {
        setFacture(fact)
    }
    $(tableRef.current).DataTable()
    $(tableRef2.current).DataTable()
    $(tableRef3.current).DataTable()
    const location = useLocation();
    const fournsseur = location?.state?.fourn;
    const allPaiements = fournsseur?.conteneurs?.flatMap(c =>
        c.paiements.map(p => ({ ...p, conteneur: c.lib_conteneur, devise: c.devise }))
    ); //on regroupe tous les paiements
    const [selected, setSelected] = useState(null)
    useEffect(() => {
        setTotal(fournsseur.conteneurs.reduce((previous, current) => { return previous + current.prix_total }, 0));
        setTotalPaye(allPaiements.reduce((previous, current) => { return previous + current.montant }, 0));
        setTotalAvance(fournsseur.avances.reduce((previous, current) => { return previous + current.montant }, 0));
    }, [fournsseur])

    return (
        <div className="compte">
            <h4>COMPTE FOURNISSEUR: {`${fournsseur?.prenoms} ${fournsseur?.nom}`} </h4>
            <div className="accordion" id="accordionExample">
                <div className="table-responsive ">
                    <h6 className="text-secondary text-uppercase"></h6>
                    {
                        <>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <div className="row">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#item-conteneurs" aria-expanded="true" aria-controls="collapseOne">
                                            <div className="row justify-content-between  w-100 text-secondary">
                                                <span className="col-10">Liste des conteneurs</span>
                                                <span className="col-2 fw-bold">Total: {total.toLocaleString()}</span>
                                            </div>
                                        </button>
                                    </div>
                                </h2>
                                <div id="item-conteneurs" className="accordion-collapse collapse " data-bs-parent="#accordionExample">
                                    <div className="accordion-body">

                                        {fournsseur?.conteneurs?.length > 0 ? <table ref={tableRef} className="table table-white shadow table-bordered table-hover table-striped border-primary">
                                            <thead className="table-dark border-primary">
                                                <tr className="text-center">
                                                    <th >N°CONT</th>
                                                    <th>CONTENEURS</th>
                                                    <th> MONTANT</th>
                                                    <th> PAYE</th>
                                                    <th> RESTE</th>
                                                    <th>DATE</th>
                                                    <th className="text-end">ACTIONS</th>
                                                </tr>
                                            </thead>
                                            <tbody className="plage">

                                                {
                                                    fournsseur?.conteneurs?.map((cont, ind) => (
                                                        <tr key={ind}>
                                                            <td>{cont.numero}</td>
                                                            <td>{cont.lib_conteneur}</td>
                                                            <td>{cont.prix_total?.toLocaleString()} {cont.devise}</td>
                                                            <td>{cont.montant_paye?.toLocaleString()} {cont.devise}</td>
                                                            <td>{(cont.prix_total - cont.montant_paye)?.toLocaleString()} {cont.devise}</td>
                                                            <td>{cont.created_at}</td>
                                                            <td className="text-end">
                                                                {user.droit === 'Comptable' &&
                                                                    <>

                                                                        <button className="btn btn-primary m-1" data-bs-toggle="modal" data-bs-target="#paiement" onClick={() => handleSetSelect(cont)}><i className="bx bx-show"></i></button>
                                                                    </>
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))
                                                }


                                            </tbody>
                                        </table> : <div className="bg-danger-subtle fs-4 text-danger p-2 text-center">Aucune facture pour ce fournisseur!</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#item-paiements" aria-expanded="true" aria-controls="collapseOne">
                                        <div className="row justify-content-between  w-100 text-secondary">
                                            <span className="col-10">  Paiements et remboursements conteneus</span>
                                            <span className="col-2 fw-bold">Total Paye: {totalPaye.toLocaleString()}</span>
                                        </div>

                                    </button>
                                </h2>
                                <div id="item-paiements" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        {allPaiements?.length > 0 ?
                                            <table ref={tableRef2} className="table table-white shadow table-bordered table-hover table-striped border-primary">
                                                <thead className="table-success border-primary">
                                                    <tr className="text-center">
                                                        <th >N°</th>
                                                        <th> MONTANT</th>
                                                        <th>CONTENEURS</th>
                                                        <th>Source</th>
                                                        <th>DATE</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        allPaiements?.map((paie, ind) => (
                                                            <tr key={ind}>
                                                                <td>{ind + 1}</td>
                                                                <td>{paie.montant.toLocaleString()} {paie.devise}</td>
                                                                <td>{paie.conteneur.toUpperCase()}  </td>
                                                                <td>{paie.source.toUpperCase()}  </td>
                                                                <td>{paie.created_at}  </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table> : <div className="bg-danger-subtle fs-4 text-danger p-2 text-center">Aucun paiement effectue!</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#item-avances" aria-expanded="true" aria-controls="collapseOne">
                                        <div className="row justify-content-between  w-100 text-secondary">
                                            <span className="col-10">Liste des Avances</span>
                                            <span className="col-2 fw-bold">Solde Avances: {totalAvance.toLocaleString()}</span>
                                        </div>

                                    </button>
                                </h2>
                                <div id="item-avances" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        {fournsseur?.avances?.length > 0 ? <table ref={tableRef3} className="table table-white shadow table-bordered table-hover table-striped border-primary">
                                            <thead className="table-dark border-primary">
                                                <tr className="text-center">
                                                    <th >N°</th>
                                                    <th> MONTANT</th>
                                                    {/* <th hidden>Source</th> */}
                                                    <th>Description</th>
                                                    <th>DATE</th>
                                                    {user.droit === 'Comptable' && <th>ACTIONS</th>}

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    fournsseur?.avances?.map((paie, ind) => (
                                                        <tr key={ind} className={`${paie.montant > 0 ? "bg-success-subtle" : "bg-danger-subtle"}`}>
                                                            <td>{ind + 1}</td>
                                                            <td>{paie.montant.toLocaleString()} {paie.devise}</td>
                                                            {/* <td hidden>{paie.source.toUpperCase()}  </td> */}
                                                            <td>{paie.descriptions?.toUpperCase()}  </td>
                                                            <td>{paie.created_at} </td>
                                                            {user.droit === 'Comptable' && <th>
                                                                <button className="btn btn-primary m-1" data-bs-toggle="modal" data-bs-target="#modal-edite-avance-fourn" onClick={() => setSelected(paie)}><i className="bx bx-edit"></i></button>
                                                                <button className="btn btn-danger m-1" onClick={() => deleter(`fournisseur/avance/${paie.id}/delete`)}><i className="bx bx-trash" ></i></button>
                                                            </th>}
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table> : <div className="bg-danger-subtle fs-4 text-danger p-2 text-center">Aucune avance versee pour ce fournisseur!</div>}
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
            <Paiements paiements={selectedFacture?.paiements} />
            <ModalEditeAvanceFournisseur avance={selected} />
        </div>

    );
}

export default CompteFournisseur;